"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
const ComponentContainer_1 = require("../container/ComponentContainer");
class Page extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            blocks: this.props.pathContext.blocks,
            meta: this.props.pathContext.meta,
            gaTrackingId: this.props.pathContext.gaTrackingId,
            facebookPixelId: this.props.pathContext.facebookPixelId,
            template: this.props.pathContext.template,
            theme: this.props.pathContext.theme,
            locale: this.props.pathContext.locale,
            activeLocale: this.props.pathContext.activeLocale,
            partners: this.props.pathContext.partners,
            preferredLanguage: this.props.pathContext.preferredLanguage,
            loginModalOpen: false,
            redirectToMyPage: false
        };
    }
    render() {
        return (React.createElement("div", null,
            this.renderHelmet(),
            this.renderPage()));
    }
    renderHelmet() {
        const meta = this.state.meta;
        const gaTrackingId = this.state.gaTrackingId;
        const facebookPixelId = this.state.facebookPixelId;
        const favicon = this.state.theme.favicon;
        // TODO: once all <a> replaced with Link
        // ga('set', 'page', '/new-page.html');
        return (React.createElement(react_helmet_1.default, null,
            React.createElement("title", null, meta.title),
            React.createElement("meta", { name: "description", content: meta.description }),
            React.createElement("meta", { name: "keywords", content: meta.keywords }),
            React.createElement("link", { rel: "icon", type: 'image/x-icon', href: favicon }),
            gaTrackingId && (React.createElement("script", { src: `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`, async: true })),
            gaTrackingId && (React.createElement("script", null, `window.dataLayer = window.dataLayer || []; window.gtag = function gtag(){window.dataLayer.push(arguments)}; window.gtag('js', new Date()); window.gtag('config', '${gaTrackingId}');`)),
            facebookPixelId &&
                React.createElement("script", null, `!function (f, b, e, v, n, t, s) {
                                if (f.fbq) return;
                                n = f.fbq = function () {
                                    n.callMethod ?
                                        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                                };
                                if (!f._fbq) f._fbq = n;
                                n.push = n;
                                n.loaded = !0;
                                n.version = '2.0';
                                n.queue = [];
                                t = b.createElement(e);
                                t.async = !0;
                                t.src = v;
                                s = b.getElementsByTagName(e)[0];
                                s.parentNode.insertBefore(t, s)
                            }(window, document, 'script',
                                'https://connect.facebook.net/en_US/fbevents.js');
                                fbq('init', ${facebookPixelId});
                                fbq('track', 'PageView');
                           `),
            React.createElement("script", { src: "https://s1.adform.net/banners/scripts/adx.js", defer: true })));
    }
    findBlocks(row, column) {
        const blocks = this.state.blocks.filter(b => (b.place.row === row && b.place.column === column));
        return blocks.sort((block1, block2) => (block1.place.order - block2.place.order));
    }
    getBlockProps(block) {
        const blockProps = { ...block.data };
        if (block && !block.data) {
            console.log(block);
        }
        blockProps.preferredLanguage = this.state.preferredLanguage;
        blockProps.localePrefix = this.resolveLocalePrefix(block.data.locale);
        return {
            Component: ComponentContainer_1.default.get(block.component),
            props: blockProps
        };
    }
    resolveLocalePrefix(locale) {
        return this.state.locale.default === locale ? '' : `/${locale}`;
    }
}
exports.Page = Page;



// WEBPACK FOOTER //
// ./src/core/base/Page.tsx